import { SiteLink } from '../components/site-link';
import { useUrlLocale } from '../i18n/url-locale';
import { getHomeContent } from '../lib/content';
import { usePageTitle } from '../lib/use-page-title';
import { StatusBadge } from '../components/status-badge';

export function HomePage() {
  const locale = useUrlLocale();
  const page = getHomeContent(locale);
  usePageTitle('/', page.meta.title);
  return (
    <>
      <section className="hero">
        <div className="container">
          <p className="eyebrow">{page.hero.eyebrow}</p>
          <h1>{page.hero.headline}</h1>
          <p className="lead">{page.hero.subhead}</p>
          <div className="actions">
            <SiteLink className="button button-primary" to="/product">
              {page.hero.primaryCtaLabel}
            </SiteLink>
            <SiteLink className="button button-secondary" to="/contact">
              {page.hero.secondaryCtaLabel}
            </SiteLink>
          </div>
        </div>
      </section>

      <section className="section" aria-labelledby="foundation-title">
        <div className="container">
          <div className="section-heading">
            <h2 id="foundation-title">{page.foundation.title}</h2>
            <StatusBadge status="in-development" />
          </div>
          <p className="section-intro">{page.foundation.intro}</p>
          <ul className="card-grid">
            {page.foundation.items.map((item) => (
              <li key={item.title} className="card">
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section section-sunken" aria-labelledby="planned-title">
        <div className="container">
          <div className="section-heading">
            <h2 id="planned-title">{page.planned.title}</h2>
            <StatusBadge status="planned" />
          </div>
          <p className="section-intro">{page.planned.intro}</p>
          <ul className="card-grid">
            {page.planned.items.map((item) => (
              <li key={item.title} className="card card-planned">
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section" aria-labelledby="closing-title">
        <div className="container narrow">
          <h2 id="closing-title">{page.closing.title}</h2>
          <p>{page.closing.body}</p>
          <SiteLink className="button button-primary" to="/contact">
            {page.closing.ctaLabel}
          </SiteLink>
        </div>
      </section>
    </>
  );
}
